import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css'
import RangeSlider from 'react-bootstrap-range-slider'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import NumberFormat from 'react-number-format'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { validateUEN } from '../../../../_metronic/helpers/validation'
import { fetchStartWithForward } from '../../../../redux/actions/common'
import {
  deleteApplicationDetails,
  saveApplicationDetails,
  setLoanApplication,
} from '../redux/actions'
import { trim } from '../../../../_metronic/helpers'
import { MaintenanceModeBanner } from '../../../../_metronic/helpers/components/MaintenanceModeBanner'
import { getStoredEnv } from '../../../../utils/getIntegrationURLFromENV'
import { RightAeroIcon } from '../../../../svg/RightAeroIcon'
import { LeftArowIcon } from '../../../../svg/LeftArowIcon'
import { AlexiApplicationTypes } from '../../../../utils/constants/AlexiApplicationType.enum'
import { useHistory } from 'react-router-dom'
import { parsePhoneNumberWithError } from 'libphonenumber-js/max'

import { isValidPhoneNumber } from 'libphonenumber-js'

const errorMsg = {
  required: 'required',
  amountRange: 'Amount range should be between 75,000 - 500,000',
  durationRange: 'Duration range should be between 3 - 12 months',
}

export const scrollToErros = () => {
  setTimeout(() => {
    document.getElementsByClassName('text-danger').length > 0 &&
      document.getElementsByClassName('text-danger')[0].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      })
  }, 1000)
}

const Step1Sub1: FC<any> = ({ createApplication, mobileNo }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const maxAmount = 500000
  const minAmount = 75000
  const maxDuration = 12
  const minDuration = 3

  const [loanAmountRange, setLoanAmountRange] = useState<any>(75000)
  const [loanDurationRange, setLoanDurationRange] = useState<any>(6)
  // const [mobileNo, setMobileNo] = useState<any>('+977984');
  // const [sendOTP, {data,loading,error}] = useMutation(mutations.SEND_OTP, { variables: { mobileNo, isApplicantOrShareholder: true } });

  const savedApplicationDetails = useSelector((state: any) => state.loan.loanApplication)

  const handleLoanAmountRange = (value: string) => {
    dispatch(saveApplicationDetails(formik.values))
    dispatch(setLoanApplication(formik.values))
    setLoanAmountRange(value)
    formik.setFieldValue('amountRequested', value)
    //if(error.match(/ name/i)) formik.setFieldError('name', error);
  }

  const handleLoanDurationRange = (value: string) => {
    dispatch(saveApplicationDetails(formik.values))
    dispatch(setLoanApplication(formik.values))
    setLoanDurationRange(value)
    formik.setFieldValue('durationInMonths', value)
  }
  const backLink = () => {
    const applicationType = localStorage.getItem('loanType')
    if (applicationType === AlexiApplicationTypes.LOAN_APPLICATION) {
      history.push('/')
    }
  }

  const initialValues = {
    applicantName: '',
    // applicationStatus: '',
    companyUEN: '',
    positionInCompany: '',
    amountRequested: loanAmountRange,
    durationInMonths: loanDurationRange,
    mobileNumber: mobileNo ? mobileNo : '',
    promoCode: '',
  }

  const validationSchema = Yup.object().shape({
    amountRequested: Yup.number()
      .required(errorMsg.required)
      .min(minAmount, errorMsg.amountRange)
      .max(maxAmount, errorMsg.amountRange),
    durationInMonths: Yup.number()
      .required(errorMsg.required)
      .min(minDuration, errorMsg.durationRange)
      .max(maxDuration, errorMsg.durationRange),
    companyUEN: Yup.string()
      .required('Company UEN is required')
      .test('unique', 'Invalid UEN. Kindly recheck the entered UEN', (value: any) =>
        validateUEN(value)
      ),
    positionInCompany: Yup.string()
      .required('Position In Company is required')
      .test('unique', 'Position must not contain numbers', (value: any) => {
        return !/\d/.test(value)
      }),
    applicantName: Yup.string()
      .required('Business Owner Name is required')
      .matches(
        /^[A-Za-z\s.']+$/,
        'Please enter a valid Business Owner Name using letters, spaces, periods, or apostrophes, and include at least 2 letters.'
      )
      .test(
        'at-least-two-letters',
        'Business Owner Name cannot contain only special characters. Please enter a valid business owner name.',
        (value: any) => {
          if (!value) return false
          const letters = value.match(/[A-Za-z]/g)
          return (letters?.length || 0) >= 2
        }
      ),
    promoCode: Yup.string(),
    mobileNumber: Yup.string()
      .required('Mobile number is required')
      .test('mobileValidation', 'Please enter valid Singapore number', (value: any) => {
        if (!value) return false
        // Use libphonenumber-js to validate phone number format
        const number = parsePhoneNumberWithError(value, 'SG')
        // Use libphonenumber-js to validate phone number format
        return (
          isValidPhoneNumber(value, 'SG') &&
          number.isValid() &&
          number.country === 'SG' &&
          number.country === 'SG'
        )
      }),
    //TODO: add validation on prod
    // ,(value:any) => {
    //   if(/^\+65(8|9)\d{7}$/g.test(value) || /^\+977\d{10}$/g.test(value)){
    //     return true
    //   }
    //   return false
    // })
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: savedApplicationDetails || initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      const {
        amountRequested,
        durationInMonths,
        companyUEN,
        positionInCompany,
        applicantName,
        mobileNumber,
        promoCode,
      } = trim(values)

      dispatch(fetchStartWithForward())
      if (
        localStorage.getItem('loanType') === null ||
        localStorage.getItem('loanType') === undefined
      ) {
        localStorage.setItem('loanType', AlexiApplicationTypes.LOAN_APPLICATION)
      }
      createApplication({
        variables: {
          data: {
            amountRequested: amountRequested * 1,
            durationInMonths: durationInMonths * 1,
            companyUEN,
            mibCompanyUEN: companyUEN,
            positionInCompany,
            applicantName,
            mobileNumber,
            promoCode,
            applicationStatus: 'in-progress',
            applicationCompleteStep: 1.1,
            applicationType:
              localStorage.getItem('loanType') || AlexiApplicationTypes.LOAN_APPLICATION,
            partnerId: localStorage.getItem('partnerId') || '',
            credilinqEnvironment: getStoredEnv(),
          },
        },
      })
      setSubmitting(false)
    },
  })

  useEffect(() => {
    return () => {
      dispatch(deleteApplicationDetails())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className='d-flex flex-column flex-column-fluid'>
      <MaintenanceModeBanner />

      <form onSubmit={formik.handleSubmit} noValidate>
        <div className='cardNew'>
          <div className='section-heading'>
            <h2>Loan Details</h2>
            <hr className='text-gray-400' />
          </div>

          <div className='row'>
            <div className='col-md-6'>
              <label htmlFor='' className='input-field-label required'>
                I want to borrow
              </label>
              <NumberFormat
                name='amountRequested'
                value={formik.values.amountRequested}
                className='form-control form-control-solid'
                // displayType={'text'}
                allowNegative
                thousandSeparator={true}
                prefix={'SG$ '}
                onValueChange={(values: any) => {
                  let { value } = values
                  formik.setFieldValue('amountRequested', value)
                }}
                onBlur={(event: any) => {
                  let { value } = event.target
                  // For negative values, we need special handling since the prefix is at the beginning
                  // Check if the value contains a negative sign
                  const isNegative = event.target.value.includes('-')

                  // Remove the prefix (SGD$) and any commas
                  if (isNegative) {
                    // For negative values, the format might be -SGD$200,000 or SGD$-200,000
                    value = value.replace(/[SGD$,]/g, '')
                  } else {
                    value = value.substring(4) // Remove prefix
                    value = value.replace(/[,$]/g, '') // Remove commas and any dollar signs
                  }

                  let parsedValue = value ? parseFloat(value) : 0

                  // Always keep the original entered value, including negative values
                  formik.setFieldValue('amountRequested', parsedValue)
                  // Show appropriate validation errors
                  if (Number(parsedValue) < 0) {
                    formik.setFieldError('amountRequested', 'Amount cannot be negative')
                    formik.setFieldValue('amountRequested', parsedValue)
                  } else if (Number(parsedValue) === 0) {
                    formik.setFieldError('amountRequested', 'Amount cannot be zero')
                    formik.setFieldValue('amountRequested', parsedValue)
                  } else if (Number(parsedValue) < minAmount) {
                    formik.setFieldError(
                      'amountRequested',
                      `Amount cannot be less than SGD$${minAmount.toLocaleString()}`
                    )
                    formik.setFieldValue('amountRequested', parsedValue)
                  } else if (Number(parsedValue) > maxAmount) {
                    formik.setFieldError(
                      'amountRequested',
                      `Amount cannot exceed SGD$${maxAmount.toLocaleString()}`
                    )
                    formik.setFieldValue('amountRequested', parsedValue)
                  } else {
                    // Only round valid values
                    let roundedValue = Math.round(Number(parsedValue) / 500) * 500
                    formik.setFieldValue('amountRequested', roundedValue)
                  }

                  formik.setFieldTouched('amountRequested', true)
                }}
              />
              {formik.touched.amountRequested && formik.errors.amountRequested && (
                <div className='text-danger mt-2'>{formik.errors.amountRequested}</div>
              )}
              <RangeSlider
                // id="amountRequested"
                min={minAmount}
                max={maxAmount}
                step={5000}
                tooltip='on'
                tooltipPlacement='top'
                tooltipLabel={(currentValue) => `SG$ ${currentValue}`}
                value={formik.values.amountRequested}
                onChange={(event: any) => {
                  handleLoanAmountRange(event.target.value)
                }}
                className='rangeSlider'
                // onChange={({target:{value}}) => { if(regexNumber.test(value)) formik.setFieldValue('total', value) }}
                // onChange={formik.handleChange}
              />
              <div className='d-flex flex-row justify-content-between'>
                <div>SG$ 75,000</div>
                <div>SG$ 500,000</div>
              </div>
            </div>
            <div className='col-md-6'>
              <label htmlFor='' className='input-field-label required'>
                How long for? (Months)
              </label>
              <input
                name='durationInMonths'
                type='number'
                min={minDuration}
                max={maxDuration}
                step={1}
                className='form-control form-control-solid'
                value={formik.values.durationInMonths}
                onChange={formik.handleChange}
                onBlur={(event: any) => {
                  let { value } = event.target
                  value = value ? parseInt(value) : 0
                  value = Math.min(maxDuration, Math.max(minDuration, value))
                  formik.setFieldValue('durationInMonths', value)
                }}
              />
              {formik.touched.durationInMonths && formik.errors.durationInMonths && (
                <div className='text-danger mt-2'>{formik.errors.durationInMonths}</div>
              )}
              <RangeSlider
                // id="durationInMonths"
                min={3}
                max={12}
                tooltip='on'
                tooltipPlacement='top'
                tooltipLabel={(currentValue) => `${currentValue} months`}
                value={formik.values.durationInMonths}
                // onChange={formik.handleChange}
                onChange={(event: any) => {
                  handleLoanDurationRange(event.target.value)
                }}
                className='rangeSlider'
              />
              <div className='d-flex flex-row justify-content-between'>
                <div>3 months</div>
                <div>12 months</div>
              </div>
            </div>
          </div>
        </div>
        <div className='cardNew'>
          <div className='section-heading'>
            <h2>Company Details</h2>
            <hr className='text-gray-400' />
          </div>
          <div className='row'>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Company UEN
              </label>
              <input
                name='companyUEN'
                type='text'
                className='form-control form-control-solid'
                value={formik.values.companyUEN}
                onChange={formik.handleChange}
              />
              {formik.touched.companyUEN && formik.errors.companyUEN && (
                <div className='text-danger mt-2'>{formik.errors.companyUEN}</div>
              )}
            </div>
            <div className='col-md-6 mb-5'>
              {' '}
              <label htmlFor='' className='input-field-label required'>
                Position within company
              </label>
              <input
                name='positionInCompany'
                type='text'
                className='form-control form-control-solid'
                value={formik.values.positionInCompany}
                onChange={formik.handleChange}
              />
              {formik.touched.positionInCompany && formik.errors.positionInCompany && (
                <div className='text-danger mt-2'>{formik.errors.positionInCompany}</div>
              )}
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Applicant Name
              </label>
              <input
                name='applicantName'
                type='text'
                className='form-control form-control-solid'
                value={formik.values.applicantName}
                onChange={formik.handleChange}
              />
              {formik.touched.applicantName && formik.errors.applicantName && (
                <div className='text-danger mt-2'>{formik.errors.applicantName}</div>
              )}
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Mobile Number
              </label>
              <PhoneInput
                id='mobileNumber'
                international
                defaultCountry='SG'
                // countryCallingCodeEditable={false}
                value={formik.values.mobileNumber}
                onChange={(value) => formik.setFieldValue('mobileNumber', value)}
                placeholder='Enter phone number'
                className='int-phone-input'
              />
              {(formik.touched.mobileNumber || formik.values.mobileNumber === undefined) &&
                formik.errors.mobileNumber && (
                  <div className='text-danger mt-2'>{formik.errors.mobileNumber}</div>
                )}
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <label htmlFor='' className='input-field-label'>
                Promo Code
              </label>
              <input
                name='promoCode'
                type='text'
                className='form-control form-control-solid'
                value={formik.values.promoCode}
                onChange={formik.handleChange}
              />
            </div>
          </div>
        </div>

        <div className='cardNew stickeyFooter'>
          <div className='d-flex justify-content-between'>
            <button className='button button-outline-back' onClick={backLink}>
              <span className='icon-text me-3'>
                <LeftArowIcon color='currentColor' />
                Back
              </span>
            </button>
            <button
              type='submit'
              className='button button-primary '
              onClick={() => {
                scrollToErros()
              }}
            >
              Send OTP <RightAeroIcon color='currentColor' />
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export { Step1Sub1 }
